import ThemeSwitch from "./ThemeSwitch";

type Props = {
  logo?: boolean
}
function TopBar({ logo = true }: Props) {
  const icon = require("../../assets/gdol.png")

  return (
    <div className="top-0 fixed w-full h-16 border-b-[1px] border-b-border-light-gray dark:border-b-border-dark-gray bg-light-gray dark:bg-background-dark flex flex-row items-center justify-between px-4 z-50">
      <div>
        {
          logo == true &&
          <img src={icon} alt="" className="w-[65px]" />
        }
      </div>
      <div>
        <ThemeSwitch label={false} />
      </div>
    </div>
  );
}

export default TopBar;